import React, { useContext, useLayoutEffect, useRef, useState } from "react";
import ModalContext from "../../../Contexts/openModal";
import "../../../styles/components/Slices/HeroDali.scss";
import CustomButton from "../../CustomButton";
import SingleEmailForm2 from "../../Pieces/SingleEmailForm2";
import { GatsbyImage, getImage } from "gatsby-plugin-image";
import CtaBannerMunchForm from "../../Pieces/CtaBannerMunchForm";

export const DaliHeroSection = ({ slice, location }) => {
  
  const { toggleModal, setEmail } = useContext(ModalContext);
  const robotics = location?.pathname === "/the-rise-of-intelligent-machines/";
  const Rectangle =
    slice?.primary?.caption_title_dropdown == "rounded rectangle";
  const PlainHeroText =
    slice?.primary?.caption_title_dropdown == "plain hero text";

  const scrollToSection = (url) => {
    if (url && url?.charAt(0) === "#") {
      const sectionId = url.substring(1);
      const section = document.getElementById(sectionId);
      if (section) {
        const elementPosition = section.getBoundingClientRect().top;
        const offsetPosition = elementPosition + window.scrollY - 70;
        window.scrollTo({ top: offsetPosition, behavior: "smooth" });
      }
    } else toggleModal();
  };
  const isUrl =
    slice?.primary?.secondary_cta_link?.url &&
    slice?.primary?.secondary_cta_link?.url.charAt(0) !== "#";

  return (
    <section className="space-y-5 lg:max-w-[553px] sm:space-y-7">
      <p
        className={`uppercase tracking-widest_1 font-semibold font-manrope ${
          Rectangle
            ? "bg-purple-2001 text-xs rounded-md !text-purple-1100 max-w-fit px-3 py-1.5 "
            : "text-purple-1500 text-xs sm:text-base"
        }`}
      >
        {slice?.primary?.caption_title?.text}
      </p>
      <div
        role="heading"
        aria-level="2"
        className="text-3.25xl leading-10 sm:text-[60px] sm:leading-[68px] text-purple-1100 dali_strong font-semibold font-manrope sm:-tracking-[3px] tracking-tightest_7"
        dangerouslySetInnerHTML={{ __html: slice?.primary?.title?.html }}
      />
      <div
        className={`text-gray-600 tracking-tight_1 h-full dali-description ${!slice?.primary?.show_bg ? "max-w-full" : "sm:max-w-[550px] lg:max-w-full"}`}
        dangerouslySetInnerHTML={{
          __html: slice?.primary?.descriptor_text?.html,
        }}
      />
      {slice?.primary?.show_email_cta && robotics ? (
        <CtaBannerMunchForm
          openModal={toggleModal}
          setEmail={setEmail}
          buttonText={slice?.primary?.cta_text?.text || "Get started"}
          formHsClass={slice?.primary?.hs_class?.text}
          formId={slice?.primary?.hs_id?.text}
          pagePath={robotics}
        />
      ) : slice?.primary?.show_email_cta ? (
        <SingleEmailForm2
          openModal={toggleModal}
          setEmail={setEmail}
          buttonText={slice?.primary?.cta_text?.text || "Get started"}
          formHsClass={slice?.primary?.hs_class?.text}
          formId={slice?.primary?.hs_id?.text}
        />
      ) : slice?.primary?.cta_text?.text &&
        slice?.primary?.secondary_cta_text?.text ? (
        <div className="flex flex-col xs:flex-row gap-3">
          {slice?.primary?.cta_text?.text && (
            <CustomButton
              onClick={toggleModal}
              link={slice?.primary?.cta_link?.url}
              buttonClass="bg-purple-1500 text-white"
              text={slice?.primary?.cta_text?.text}
            />
          )}
          {slice?.primary?.secondary_cta_link?.url && (
            <CustomButton
              onClick={() =>
                scrollToSection(slice?.primary?.secondary_cta_link?.url)
              }
              link={isUrl && slice?.primary?.secondary_cta_link?.url}
              buttonClass="bg-white hover:border-gray-2500 text-gray-2500 border border-gray-2200"
              text={slice?.primary?.secondary_cta_text?.text}
            />
          )}
        </div>
      ) : slice?.primary?.cta_text?.text ? (
        slice?.primary?.cta_link?.url && (
          <CustomButton
            onClick={toggleModal}
            link={slice?.primary?.cta_link?.url}
            buttonClass="bg-purple-1500 text-white"
            text={slice?.primary?.cta_text?.text}
          />
        )
      ) : null}
    </section>
  );
};

export const HeroDali = ({ slice, location }) => {
  const showBg = slice?.primary?.show_bg !== false;
  const backgroundImage = slice?.primary?.background_image?.url;

  return (
    <article className="pt-10">
      <div className="full-width-split-screen">
        <DaliHeroSection location={location} slice={slice} />
        <div
          className={`bg_image_dali bg-cover bg-center bg-no-repeat ${!showBg && "lg:max-w-[1020px]"} `}
          style={{
            backgroundImage: showBg
              ? `url(${backgroundImage || "https://images.prismic.io/encord/Z-5KrHdAxsiBwQl5_daliBg.png?auto=format,compress"})`
              : "none",
          }}
        >
          {/* <GatsbyImage
            image={getImage(slice?.primary?.image)}
            alt="Hero image"
            loading="eager"
            fetchPriority="high"
            sizes="(max-width: 512px) 100vw, 512px,(max-width: 1440px) 720px, 1197px"
            imgClassName="max-w-[1020px]"
          /> */}
          <img
            alt="Hero image"
            loading="eager"
            src={slice?.primary?.image?.url}
          />
        </div>
      </div>
    </article>
  );
};
